import { gql } from 'graphql.macro';

export const webhookDeliveryFieldsFragment = gql`
    fragment webhookDeliveryFields on WebhookDelivery {
        _id
        subscriptionId
        subscriptionName
        organization
        entity
        operation
        entityId
        attempts
        nextAttemptAt
        status
        lastError
        lastStatusCode
        lastDeliveryId
        createdAt
        updatedAt
    }
`;

export const getWebhookDeliveriesForOrganizationTemplate = gql`
    query webhookDeliveriesForOrganization(
        $organizationId: MongoDbObjectId!
        $filters: WebhookDeliveryFilters
        $limit: Int
        $offset: Int
    ) {
        webhookDeliveriesForOrganization(
            organizationId: $organizationId
            filters: $filters
            limit: $limit
            offset: $offset
        ) {
            items {
                ...webhookDeliveryFields
            }
            total
            limit
            offset
        }
    }
    ${webhookDeliveryFieldsFragment}
`;
